import Markdown from "./Markdown";

export const selectable = true;
export default Markdown;
